import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './index.css';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  title: string;
  content: React.ReactNode;
  footerActions?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'fullscreen' | undefined;
};

const DynamicModal: React.FC<Props> = ({
  isOpen,
  toggle,
  title,
  content,
  footerActions,
  size = 'lg',
}: Props) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size={size} zIndex={9999}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>{content}</ModalBody>
      <ModalFooter>{footerActions}</ModalFooter>
    </Modal>
  );
};

export default DynamicModal;
